import React, { useCallback } from 'react'

import { useSelector } from 'react-redux'
import { Menu } from 'antd'
import { faBusinessTime } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../../Components/icons/IconLabel'
import RequestStateCheckbox from './RequestStateCheckbox'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'

export const getActiveFiltersCount = (filters) => {
  const filtersState = filters ?? {}
  let count = 0

  if (Array.isArray(filtersState.states) && filtersState.states.length > 0) {
    count += 1
  }

  return count
}

const InternshipRequestFilters = ({ filters, onFiltersChange }) => {
  const t = useSelector(selectTranslate)

  const handleFilterChange = useCallback(
    states => onFiltersChange({ ...filters, states }),
    [onFiltersChange, filters]
  )

  return (
    <Menu inlineIndent={0}>
      <div className='h-spacing pdt-8' />
      <Menu.ItemGroup title={<IconLabel fontSize={FontSizes.SMALL} padding={0} icon={faBusinessTime} text={t('common.state')} />}>
        <RequestStateCheckbox value={filters?.states ?? []} onCheck={handleFilterChange} />
      </Menu.ItemGroup>
    </Menu>
  )
}

export default InternshipRequestFilters
